import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import { BackupOriginatorTemplate } from '~/backup/originator/domains/page/ui/BackupOriginatorTemplate';
import { AgentView } from '~/backup/shared/views/agent/AgentView';
import { BackupDataPipelineRoutes } from '~/backup/shared/views/data-pipeline/DataPipelineRoutes';
import { UploadView } from '~/backup/shared/views/upload/UploadView';
import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { DefaultErrorRoute } from '~/core/DefaultErrorRoute';

export const BackupOriginatorRouter = (): React.ReactElement => {
  return (
    <BackupOriginatorTemplate>
      <Routes>
        <Route
          path="/upload"
          element={
            <RouteErrorBoundary
              resetAfterCatch={false}
              fallback={({ message, showErrorToast }) => {
                showErrorToast(message);
                return <DefaultErrorRoute />;
              }}
            >
              <UploadView />
            </RouteErrorBoundary>
          }
        />
        <Route path="/data-pipeline/*" element={<BackupDataPipelineRoutes />} />
        <Route
          path="/agent"
          element={
            <RouteErrorBoundary
              resetAfterCatch={false}
              fallback={({ message, showErrorToast }) => {
                showErrorToast(message);
                return <DefaultErrorRoute />;
              }}
            >
              <AgentView />
            </RouteErrorBoundary>
          }
        />
        <Route path="/" element={<Navigate to="/upload" replace />} />
        <Route path="/*" element={<Navigate to="/upload" replace />} />
      </Routes>
    </BackupOriginatorTemplate>
  );
};
